import script from "./CartItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./CartItemList.vue?vue&type=script&setup=true&lang=js"

import "./CartItemList.vue?vue&type=style&index=0&id=2c018dec&lang=scss"

const __exports__ = script;

export default __exports__